import { h } from 'vue';
import Chart from 'chart.js';

/**
 * Minimal chart.js (v2) wrapper, ported to Vue 3.
 *
 * This file never used `vue-chartjs` — it wraps chart.js directly — so the only
 * migration needed was porting the Vue 2 render function (`createElement` with
 * `attrs`) to the flat Vue 3 `h()` signature and `beforeDestroy` -> `beforeUnmount`.
 * The chart.js v2 config consumed by the subclasses is left untouched.
 *
 * The Chart instance is kept as a plain (non-reactive) instance field so Vue's
 * reactivity proxy never wraps the chart object.
 */
export function generateChart(chartId, chartType) {
    return {
        props: {
            chartId: {
                default: chartId,
                type: String
            },
            width: {
                default: 400,
                type: Number
            },
            height: {
                default: 400,
                type: Number
            },
            cssClasses: {
                type: String,
                default: ''
            },
            styles: {
                type: Object
            },
            plugins: {
                type: Array,
                default() {
                    return []
                }
            }
        },

        render() {
            return h(
                'div',
                {
                    style: this.styles,
                    class: this.cssClasses
                },
                [
                    h('canvas', {
                        id: this.chartId,
                        width: this.width,
                        height: this.height,
                        ref: 'canvas'
                    })
                ]
            )
        },

        data() {
            return {
                chartPlugins: this.plugins
            }
        },

        methods: {
            addPlugin(plugin) {
                this.chartPlugins.push(plugin)
            },
            generateLegend() {
                if (this._chartInstance) {
                    return this._chartInstance.generateLegend()
                }
            },
            renderChart(data, options) {
                if (this._chartInstance) this._chartInstance.destroy();
                this._chartInstance = new Chart(
                    this.$refs.canvas.getContext('2d'), {
                        type: chartType,
                        data: data,
                        options: options,
                        plugins: this.chartPlugins
                    }
                )
            }
        },
        beforeUnmount() {
            if (this._chartInstance) {
                this._chartInstance.destroy()
            }
        }
    }
}


export const BarChart = generateChart('bar-chart', 'bar');
export const LineChart = generateChart('line-chart', 'line');
export const PieChart = generateChart('pie-chart', 'pie');
export const DoughChart = generateChart('dough-chart', 'doughnut');
export const ReaderChart = generateChart('reader-chart', 'radar');
export const PolarChart = generateChart('polar-chart', 'polarArea');
export const BubbleChart = generateChart('bubble-chart', 'bubble');
export const ScatterChart = generateChart('scatter-chart', 'scatter');
export const HorizontalLineChart = generateChart('horizontal-line-chart', 'horizontalBar');

export default {
    BarChart,
    LineChart,
    PieChart,
    DoughChart,
    ReaderChart,
    PolarChart,
    BubbleChart,
    ScatterChart,
    HorizontalLineChart
};
